import imageCompression from "browser-image-compression";
import React, { useRef } from "react";
import StyledButton from "./button"; // adjust path if needed

interface FileUploadButtonProps {
  onFileSelected: (file: File) => void;
}

const FileUploadButton: React.FC<FileUploadButtonProps> = ({
  onFileSelected,
}) => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleClick = () => {
    inputRef.current?.click(); // trigger hidden input
  };

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      const compressed = await imageCompression(file, {
        maxSizeMB: 1,
        maxWidthOrHeight: 1200,
        useWebWorker: true,
      });
      onFileSelected(compressed); // pass to parent
    }
  };

  return (
    <>
      <input
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        ref={inputRef}
        style={{ display: "none" }}
      />
      <StyledButton onClick={handleClick}>📄 Choose File</StyledButton>
    </>
  );
};

export default FileUploadButton;
